export const deviceSelectId = 'gjs-device-select';

const cmdDeviceDesktop = 'set-device-desktop';
const cmdDeviceTablet = 'set-device-tablet';
const cmdDeviceTabletHorizontal = 'set-device-tablet-horizontal';
const cmdDeviceMobile = 'set-device-mobile';


const deviceCommandMap = {
    desktop: cmdDeviceDesktop,
    tabletHorizontal: cmdDeviceTabletHorizontal,
    tablet: cmdDeviceTablet,
    mobile: cmdDeviceMobile,
};
const deviceNameMap = {
    desktop: 'Desktop',
    tabletHorizontal: 'Tablet Horizontal',
    tablet: 'Tablet',
    mobile: 'Mobile portrait',
};


const getDeviceValueFromName = (name = '') => {
    const normalized = String(name).toLowerCase();
    if (normalized.includes('tablet') && normalized.includes('horizontal')) return 'tabletHorizontal';
    if (normalized.includes('tablet')) return 'tablet';
    if (normalized.includes('mobile')) return 'mobile';
    return 'desktop';
};

export const deviceChangeSelectCommand = (editor) => {
    editor.on('load', () => {
        const deviceSelect = document.getElementById(deviceSelectId);
        if (!deviceSelect) {
            return;
        }

        const setDeviceFromSelect = (value) => {
            const command = deviceCommandMap[value];
            const targetDevice = deviceNameMap[value];
            const beforeDevice = editor.getDevice();
            if (targetDevice) {
                editor.setDevice(targetDevice);
            }
            const afterDirectSet = editor.getDevice();
            if (afterDirectSet === beforeDevice && command) {
                editor.runCommand(command);
            }
        };
        setDeviceFromSelect('desktop');
        deviceSelect.addEventListener('change', (event) => {
            const { value } = event.target;
            setDeviceFromSelect(value);
        });

        const syncSelectWithEditorDevice = (source) => {
            const editorDevice = editor.getDevice();
            const activeValue = getDeviceValueFromName(editorDevice);
            if (deviceSelect.value !== activeValue) {
                deviceSelect.value = activeValue;
            }
        };

        editor.on('change:device', () => {
            syncSelectWithEditorDevice('change:device');
        });

        editor.on(`run:${cmdDeviceDesktop}`, () => syncSelectWithEditorDevice(`run:${cmdDeviceDesktop}`));
        editor.on(`run:${cmdDeviceTabletHorizontal}`, () => syncSelectWithEditorDevice(`run:${cmdDeviceTabletHorizontal}`));
        editor.on(`run:${cmdDeviceTablet}`, () => syncSelectWithEditorDevice(`run:${cmdDeviceTablet}`));
        editor.on(`run:${cmdDeviceMobile}`, () => syncSelectWithEditorDevice(`run:${cmdDeviceMobile}`));

        editor.on('device:select', () => {
            syncSelectWithEditorDevice('device:select');
        });
    });
}